module.exports = __webpack_public_path__ + "assets/img/PEPS_AndyL_RGB_lr.dc6cc665.jpg";